export default class CoordinateSequenceFilter {
  filter(seq, i) {}
  isGeometryChanged() {}
  isDone() {}
}
